import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { Parameter } from "../models/Parameter";
import { CreateSubcontractorDTO } from "../models/Subcontractor/CreateSubcontractorDTO";
import { EditSubcontractorDTO } from "../models/Subcontractor/EditSubcontractorDTO";
import { SearchByCompanyNameDTO } from "../models/Subcontractor/SearchByCompanyNameDTO";
import { SubcontractorDTO } from "../models/Subcontractor/SubcontractorDTO";
import { SubcontractorSearchResultDTO } from "../models/Subcontractor/SubcontractorSearchResultDTO";
import { APIService } from "./APIService";

export class SubcontractorService {
    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<SubcontractorSearchResultDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Subcontractor/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<SubcontractorSearchResultDTO>(
                false,
                "Erro ao ligar ao servidor ao obter a informação dos subcontratantes",
                "",
                [],
                0,
            );
        }
    }

    async GetById(Id: number | undefined): Promise<MessagingHelper<SubcontractorDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Subcontractor/GetById/${Id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor ao obter a informação do subcontratante",
                null
            );
        }
    }

    async Create(
        subcontractor: CreateSubcontractorDTO
    ): Promise<MessagingHelper<number | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Subcontractor/Create`,
                { ...subcontractor },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<number | null>(
                false,
                "Erro ao ligar ao servidor para criar o subcontratante",
                null
            );
        }
    }

    async Edit(
        subcontractor: EditSubcontractorDTO
    ): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().put(
                `${APIService.GetURL()}/Subcontractor/Edit`,
                { ...subcontractor },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para editar o subcontratante",
                null
            );
        }
    }

    async GetByCompanyName(
        searchParams: SearchByCompanyNameDTO,
    ): Promise<MessagingHelper<SubcontractorDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Subcontractor/GetByCompanyName`,
                {
                    ...searchParams,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter os subcontratantes",
                null
            );
        }
    }
}